export const COLLAPSED_PRODUCT_COUNT = 2;

export const getVisibleProducts = (products = [], viewAll = false) => {
  if (viewAll) return products;
  return products.filter(
    (product, index) =>
      index < COLLAPSED_PRODUCT_COUNT || Boolean(product?.detail?.unavailable),
  );
};
